/**
 *
 *
 *
 *
 *
 *
 *
 */
export function jsonParseSafe<T>(value?: string | null): T {
  if (!value) {
    /*                                                */
    /*                                                                                  */
    /*                                                         */
    return value as T;
  }

  try {
    return JSON.parse(value);
  } catch {
    return value as T;
  }
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function jsonStringifySafe(value: unknown): string {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}
